import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Modal } from '../../Shared/Modal'
import { Button } from '../../Shared/Buttons'
import { CustomInput } from '../../Shared/Inputs'
import {
  FieldRow,
  TitleAndError,
  FormTItle,
  FormError,
} from '../../Shared/FormRows'
import { ContactForm, ContactTextarea, SubmitRow } from './styles'

const SUPPORT_EMAIL = 'support@althogsweet.com'

export const ContactUsModal = ({ open, onClose }) => {
  const { t } = useTranslation()
  const { register, handleSubmit, formState: { errors }, reset } = useForm()

  const onSubmit = (data) => {
    const subject = encodeURIComponent(`${t('Contact Us')} - ${data.name}`)
    const body = encodeURIComponent(
      `${t('Name')}: ${data.name}\n${t('Email')}: ${data.email}\n\n${data.message}`
    )
    window.location.href = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`
    reset()
    onClose()
  }

  return (
    <Modal
      open={open}
      title={t('Contact Us')}
      onClose={onClose}
      closeOnBackdrop
      width="500px"
      padding="20px"
    >
      <ContactForm onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <FieldRow>
          <TitleAndError>
            <FormTItle>{t('Name')} *</FormTItle>
            <FormError>{errors.name?.message}</FormError>
          </TitleAndError>
          <CustomInput
            bordered
            width="100%"
            error={errors.name}
            {...register('name', { required: t('Required') })}
          />
        </FieldRow>

        <FieldRow>
          <TitleAndError>
            <FormTItle>{t('Email')} *</FormTItle>
            <FormError>{errors.email?.message}</FormError>
          </TitleAndError>
          <CustomInput
            bordered
            width="100%"
            type="email"
            error={errors.email}
            {...register('email', {
              required: t('Required'),
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: t('Invalid email'),
              },
            })}
          />
        </FieldRow>

        <FieldRow>
          <TitleAndError>
            <FormTItle>{t('Message')} *</FormTItle>
            <FormError>{errors.message?.message}</FormError>
          </TitleAndError>
          <ContactTextarea
            error={errors.message}
            {...register('message', { required: t('Required') })}
          />
        </FieldRow>

        <SubmitRow>
          <Button color="primary" width="100%" type="submit">
            {t('Send')}
          </Button>
        </SubmitRow>
      </ContactForm>
    </Modal>
  )
}
